import React from 'react';
import { FormInputSelect } from '../../../common/formInputs/FormInputSelect';

const questions = {
  building_type: {
    label: 'Tipologia di fabbricato',
    name: 'building_type',
    options: [
      {
        id: 'Porzione di fabbricato',
        name: 'Porzione di fabbricato',
      },
      {
        id: 'Intera costruzione',
        name: 'Intera costruzione',
      },
    ],
    input_type: 'select',
  },
  activity_type: {
    label: "Selezionare l'attività svolta",
    name: 'activity_type',
    options: [
      {
        id: 'Commerciale',
        name: 'Commerciale',
      },
      {
        id: 'Industriale',
        name: 'Industriale',
      },
    ],
  },
};
function CommercialCatastropheContractorType({
  errors,
  isValid,
  register,
}) {
  return (
    <>
      <h4 className="text-center mt-3">Tipologia</h4>
      <div className="row mt-5 d-flex justify-content-center">
        <div className="col-12 col-md-6 mb-4">
          <div className="card border">
            <div className="card-body">
              <div className="col-12">
                <div
                  className="d-flex flex-column align-items-center justify-content-center gap-5"
                  style={{ maxWidth: '600px' }}
                >
                  {Object.values(questions).map((question, index) => (
                    <FormInputSelect
                      placeholder="-Seleziona-"
                      key={index}
                      label={question.label}
                      options={question.options}
                      name={question.name}
                      error={
                        errors?.type?.[question.name]?.message
                      }
                      valid={isValid(`type.${question.name}`)}
                      registration={register(
                        `type.${question.name}`,
                      )}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommercialCatastropheContractorType;
